import { Box } from '@material-ui/core';

import { NewAgent } from '../types/NewAgent';
import { AgentCard } from './AgentCard';

interface AgentsListProps {
  agents: NewAgent[];
  removeAgent: (agent: NewAgent) => void;
}

export const AgentsList = ({ agents, removeAgent }: AgentsListProps) => {
  return (
    <Box minHeight={'200px'}>
      {agents.map((agent) => (
        <AgentCard key={agent.agentId} agent={agent} removeAgent={removeAgent} />
      ))}
    </Box>
  );
};
